// extracted by mini-css-extract-plugin
export default {"article-like":"article-like--ttUtu","item":"item--VVce8","img":"img--CujCe","title":"title--Fk_sx","text":"text--e5lcw","more":"more--XVxNS"};